import { render } from "./RIcon.vue?vue&type=template&id=4f5913df&scoped=true"
import script from "./RIcon.vue?vue&type=script&lang=js"
export * from "./RIcon.vue?vue&type=script&lang=js"

import "./RIcon.vue?vue&type=style&index=0&id=4f5913df&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5913df"]])

export default __exports__